import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger } from "@nextui-org/react";
import PropTypes from "prop-types";

import { Row, SpicyButton, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

import TextStyles from "../common/TextStyles";

const ConversationMemoriesDropdown = ({ onAdd, onDelete, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dropdown offset={-20} crossOffset={-50} classNames={{ trigger: TextStyles.dropdown.trigger }} style={{ zIndex: 10000000 }}>
      <DropdownTrigger>
        <SpicyButton isIconOnly variant="primary_smallest">
          <Icon icon={IconVariants.THREE_DOTS} size={IconSize.MEDIUM} className="opacity-95" />
        </SpicyButton>
      </DropdownTrigger>
      <DropdownMenu classNames={TextStyles.dropdown.menu} className="w-full" aria-label="global-memories-options">
        <DropdownSection classNames={TextStyles.dropdown.section}>
          <DropdownItem
            classNames={TextStyles.dropdown.item_danger}
            color="danger"
            onPress={onAdd}
            textValue={t("chat:modal.memories.dropdown.addNew")}
          >
            <Row justify="between">
              <Text variant={"md"}>
                <Trans i18nKey="chat:modal.memories.dropdown.addNew" />
              </Text>
            </Row>
          </DropdownItem>
        </DropdownSection>
        <DropdownSection classNames={TextStyles.dropdown.section}>
          <DropdownItem
            classNames={TextStyles.dropdown.item_danger}
            color="danger"
            onPress={onClose}
            textValue={t("chat:modal.memories.dropdown.closeManager")}
          >
            <Row justify="between">
              <Text variant={"md"}>
                <Trans i18nKey="chat:modal.memories.dropdown.closeManager" />
              </Text>
            </Row>
          </DropdownItem>
        </DropdownSection>
        <DropdownSection classNames={TextStyles.dropdown.section}>
          <DropdownItem classNames={TextStyles.dropdown.item_primary} onPress={onDelete} textValue={t("chat:modal.memories.dropdown.deleteAll")}>
            <Row justify="between">
              <Text variant={"md"} type={"error"}>
                <Trans i18nKey="chat:modal.memories.dropdown.deleteAll" />
              </Text>
              <Icon icon={IconVariants.TRASH} size={IconSize.MEDIUM} className="text-red-600 mr-[3px]" />
            </Row>
          </DropdownItem>
        </DropdownSection>
      </DropdownMenu>
    </Dropdown>
  );
};

ConversationMemoriesDropdown.propTypes = {
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  onClose: PropTypes.func,
};

export default ConversationMemoriesDropdown;
